import React from 'react';

const RemainingPoints = ({ selectedVehicleIndex, remainingPoints, addPointToSelectedVehicle }) => {
  if (selectedVehicleIndex === null) return null;
  
  return (
    <div className="remaining-points">
      <h4>Points to add to Vehicle {selectedVehicleIndex + 1}</h4>
      
      {remainingPoints.length > 0 ? (
        <div className="remaining-points-list">
          {remainingPoints.map(point => (
            <button
              key={point.id}
              className="point-selector-btn"
              onClick={() => addPointToSelectedVehicle(point)}
            >
              {point.name}
            </button>
          ))}
        </div>
      ) : (
        <p className="no-points-message">
          No available points. All points have been assigned to paths or already exist in current path.
        </p>
      )}
    </div>
  );
};

export default RemainingPoints; 